import { message } from "antd";
import styles from "./styles.module.scss";

type MessageCaller = (data: { text: string }) => void;

export const useAlert = () => {
  const callSuccess: MessageCaller = ({ text }) => {
    message.success({
      content: text,
      className: styles.success,
    });
  };
  const callError: MessageCaller = ({ text }) => {
    message.error({
      content: text,
      className: styles.error,
    });
  };
  return { callError, callSuccess };
};
